import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Recipe from 'components/molecules/Recipe';
import CARD_RENDER_LOCATION from 'containers/molecules/Card/enum-card-render-location';
import { generateSignature } from 'helper/signature';
import { actionCreators as programItemsAC, getRecipeProductsIds } from 'store/programItems';
import { getExternalIdById, getIsMigustoRecipe, getRecipe, getRecipeFromSelectedContent } from 'store/programItems';
import { getDirectionBoundaries, getSelectedPortion, getVariantList } from 'store/recipes';
import { getIsMigrosAuthenticated } from '../../../store/login/login.selectors';

const mapStateToProps = (state: any, ownProps: any) => {
	const hasStaticSelectedContent =
		ownProps.cardRenderLocation === CARD_RENDER_LOCATION.POOL ||
		ownProps.cardRenderLocation === CARD_RENDER_LOCATION.FAVORITE;

	const externalId = hasStaticSelectedContent ? ownProps.id : getExternalIdById(state, ownProps.id);
	const selectedPortion = getSelectedPortion(state, externalId);
	const variantList = getVariantList(state, externalId);
	const directionBoundaries = getDirectionBoundaries(state, externalId);

	if (typeof ownProps.selectedContent === 'object' && ownProps.selectedContent !== null) {
		const innerrecipe = getRecipeFromSelectedContent(ownProps.selectedContent, selectedPortion);
		const innersignature = generateSignature(
			externalId,
			variantList,
			selectedPortion,
			externalId,
			(innerrecipe as any).ingredients
		);

		return {
			signature: innersignature,
			externalId,
			selectedPortion,
			variantList,
			directionBoundaries,
			recipe: innerrecipe,
			isMigustoRecipe: ownProps.selectedContent.isMigustoRecipe,
			isMigrosAuthenticated: getIsMigrosAuthenticated(state),
			productsIds: ownProps.selectedContent.productsIds,
		};
	}

	const recipe = getRecipe(state, ownProps.id, selectedPortion);
	const signature = generateSignature(
		externalId,
		variantList,
		selectedPortion,
		externalId,
		(recipe as any).ingredients
	);

	return {
		hasStaticSelectedContent,
		signature,
		externalId,
		selectedPortion,
		variantList,
		directionBoundaries,
		recipe,
		isMigustoRecipe: getIsMigustoRecipe(state, ownProps.id),
		isMigrosAuthenticated: getIsMigrosAuthenticated(state),
		productsIds: getRecipeProductsIds(state, ownProps.id),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...programItemsAC,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Recipe as any);
